import { render } from "./Main.vue?vue&type=template&id=e29c73f8"
const script = {}

import exportComponent from "/var/www/kim-new-moover/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__